import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useLang } from "../contexts/LanguageContext";
import { api, formatApiError } from "../lib/api";
import Layout from "../components/Layout";
import { Check } from "lucide-react";

const BG = "https://images.unsplash.com/photo-1491911923017-19f90d8d7f83?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export default function ResetPassword() {
  const { t } = useLang();
  const { token } = useParams();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pw !== pw2) { setErr(t.auth.mismatch); return; }
    if (pw.length < 8) { setErr("Min 8 caractères"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      setDone(true);
      setTimeout(() => nav("/login"), 2000);
    } catch (e2) { setErr(formatApiError(e2)); }
    finally { setLoading(false); }
  };

  return (
    <Layout noFooter>
      <section className="relative min-h-screen flex">
        <div className="hidden md:block w-1/2 relative">
          <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover editorial-img" />
          <div className="absolute inset-0 bg-navy/55"></div>
        </div>
        <div className="flex-1 flex items-center justify-center px-6 md:px-12 py-32">
          <div className="w-full max-w-md">
            <h1 className="font-serif text-4xl md:text-5xl font-light text-navy leading-tight mb-3">{t.auth.reset_title}</h1>
            <p className="text-ink/60 mb-10">{t.auth.reset_sub}</p>

            {done ? (
              <div data-testid="reset-done" className="flex items-start gap-3 p-5 bg-brand/10 border border-brand/30">
                <Check size={18} className="text-brand mt-0.5" />
                <span className="text-sm text-ink">{t.auth.reset_done}</span>
              </div>
            ) : (
              <form onSubmit={submit} data-testid="reset-form" className="space-y-7">
                <div>
                  <label className="block text-[10px] uppercase tracking-[0.25em] font-mono text-ink/55 mb-2">{t.auth.new_password}</label>
                  <input data-testid="reset-pw" required type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="w-full bg-transparent border-b border-ink/20 py-2 focus:outline-none focus:border-brand transition-colors" />
                </div>
                <div>
                  <label className="block text-[10px] uppercase tracking-[0.25em] font-mono text-ink/55 mb-2">{t.auth.confirm_password}</label>
                  <input data-testid="reset-pw2" required type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="w-full bg-transparent border-b border-ink/20 py-2 focus:outline-none focus:border-brand transition-colors" />
                </div>
                {err && <div data-testid="reset-error" className="text-sm text-destructive">{err}</div>}
                <button data-testid="reset-submit" disabled={loading} type="submit" className="w-full bg-brand hover:bg-brandDark disabled:opacity-60 text-white py-4 text-sm uppercase tracking-[0.18em] font-mono">
                  {loading ? "..." : t.auth.reset_submit}
                </button>
              </form>
            )}

            <div className="mt-12 pt-8 border-t border-black/10 text-xs text-ink/50">
              <Link to="/login" className="link-underline">← {t.auth.back}</Link>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
